import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Card,
  CardContent,
  Container,
  Typography
} from '@material-ui/core';
import { RegisterAmplify } from 'src/components/authentication/register';

const Register: FC = () => (
  <>
    <Helmet>
      <title>Register</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'center'
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          // my: '80px',
          pt: 3,
          boxShadow: '0px 4px 8px #0a164626',
          borderRadius: 1
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <img
            src="/favicon.svg"
            alt="Logo"
            style={{
              height: 40,
              width: 40
            }}
          />
        </Box>
        <Card>
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 4
            }}
          >
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                mb: 3
              }}
            >
              <Container
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                <Typography
                  color="textPrimary"
                  gutterBottom
                  variant="h5"
                >
                  Complete your free account setup
                </Typography>
              </Container>
            </Box>
            <Box
              sx={{
                flexGrow: 1
              }}
            >
              <RegisterAmplify />
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  </>
);

export default Register;
